export const getTimestampAfterSeconds = (seconds: number) =>
  Date.now() + seconds * 1000;
